import {
  ArrowsClockwiseIcon,
  ChartBarIcon,
  ChatTextIcon,
  DatabaseIcon,
  KeyIcon,
  ListChecksIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  TableIcon,
  ToggleRightIcon,
  UserPlusIcon,
  WrenchIcon,
} from '@phosphor-icons/react'
import type { RailConfig } from 'lib/railSections'

export const OPS_RAIL: RailConfig = {
  rowName: `Ops`,
  title: `Ops`,
  homePath: `/ops`,
  // Ops pages live under /ops, plus Fake Contacts under /agents and two under /settings, which
  // the Settings rail passes over because none of its sections are active there.
  routes: [/^\/ops(\/|$)/, /^\/agents\/fake-contacts(\/|$)/, /^\/settings\/(feature-toggles|stored-credentials)(\/|$)/],
  groups: [
    { id: `ai`, label: `AI` },
    { id: `data`, label: `Data` },
    { id: `platform`, label: `Platform` },
  ],
  sections: {
    Prompts: { group: `ai`, Icon: ChatTextIcon },
    Datasets: { group: `ai`, Icon: TableIcon },
    Evals: { group: `ai`, Icon: ListChecksIcon },
    Extraction: { group: `ai`, Icon: MagicWandIcon },
    'Search Tool': { group: `data`, Icon: MagnifyingGlassIcon },
    'Fake Contacts': { group: `data`, Icon: UserPlusIcon },
    'Pipeline Reconcile': { group: `data`, Icon: ArrowsClockwiseIcon },
    'Redis Cache': { group: `data`, Icon: DatabaseIcon },
    'Feature Toggles': { group: `platform`, Icon: ToggleRightIcon },
    'Stored Credentials': { group: `platform`, Icon: KeyIcon },
    'Usage Tracking': { group: `platform`, Icon: ChartBarIcon },
  },
  fallbackGroup: `platform`,
  fallbackIcon: WrenchIcon,
}
